import React, { useState, useEffect } from "react";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import SideBar from "../sidebar/sideBar";
import "./cards.css";
import { authSelector } from "../../store/selectors/index";
import { Modal, message } from "antd";
import { Button, Dropdown, Select, Menu } from "antd";
import { useSelector } from "react-redux";
import Popup from "../modals/Popup";
import { EMeters } from "../../enums/meters";

import {
  getAllItemsSearch,
  getAllCardSearch,
} from "../../api/endpoints/search";
import {
  deleteByDate,
  deleteSingleCardSale,
  getDataByEnteredOn,
  saveData,
  updateSale,
  descCard,
  ascCard,
  oneDayPrevious,
  oneDayNext,
} from "../../api/endpoints/card";
import { getSingleParty } from "../../api/endpoints/party";
import { latestDate } from "../../api/endpoints/meter";

const { Option } = Select;

const Cards = () => {
  const { user, access_token } = useSelector(authSelector);

  const [type, setType] = useState("ADD");
  const [dateEntered, setDateEntered] = useState("");
  const [typeLast, setTypeLast] = useState("");
  const [shift, setShift] = useState("");
  const [itemsQueue, setItemsQueue] = useState([]);
  const [editedItem, setEditedItem] = useState(null);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [modal, contextHolder] = Modal.useModal();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const [state, setState] = useState({
    items: [],
    parties: [],
    partyId: "", //ac no.
    partyName: "", // supplier name
    slipDate: "",
    batch: "",
    noOfTransaction: "",
    CCNo: "",
    itemCode: "",
    description: "",
    quantity: "",
    saleRate: "",
    charges: "",
    amount: "",
    netAmount: "",
    partyCharges: "",
  });

  const clearState = () => {
    setIsVisible(true);
    setState({
      items: state.items,
      parties: state.parties,
      partyId: "", //ac no.
      partyName: "", // supplier name
      slipDate: "",
      batch: "",
      noOfTransaction: "",
      CCNo: "",
      itemCode: "",
      description: "",
      quantity: "",
      saleRate: "",
      charges: "",
      amount: "",
      netAmount: "",
      partyCharges: "",
    });
  };

  const clearStates = () => {
    clearState();
    setEditedItem(null);
    setTypeLast("");
    setFieldsShow(false);
    setItemsQueue([]);
    setShift("");
    setDateEntered("");
    setType("ADD");
  };

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  const getAllData = async () => {
    const _items = await getAllItemsSearch(access_token);
    const _parties = await getAllCardSearch(access_token);
    setState({
      ...state,
      parties: _parties,
      items: _items,
    });
  };
  useEffect(() => {
    getAllData();

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getLatestDate = async () => {
    const _date = await latestDate(access_token);
    setDateEntered(_date.data.enteredOn);
    setShift(_date.data.shift);
    // console.log(_date, "Dateee");
  };
  useEffect(() => {
    getLatestDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Add item to que
  const addItem = () => {
    if (!state.batch || !state.partyId || !state.amount) {
      return message.error(
        `Please type ${
          !state.batch
            ? "Batch Number"
            : !state.partyId
            ? "Account Number"
            : !state.amount
            ? "Credit Amount"
            : ""
        }`
      );
    } else {
      setItemsQueue([...itemsQueue, state]);
      clearState();

      const nextInput = inputRefs["partyId"];
      if (nextInput) {
        nextInput.focus();
      }
    }
  };
  console.log(itemsQueue);

  const addSale = async () => {
    if (!dateEntered) return message.error("Please type date !");
    setIsVisible(false);
    setType("SAVE");
    setFieldsShow(true);
  };
  const editItem = async () => {
    if (state.id) {
      if (!state.batch || !state.partyId || !state.amount) {
        return message.error(
          `Please type ${
            !state.batch
              ? "Batch Number"
              : !state.partyId
              ? "Account Number"
              : !state.amount
              ? "Credit Amount"
              : ""
          }`
        );
      }
      await updateSingleApi();
    } else {
      if (!state.batch || !state.partyId || !state.amount) {
        return message.error(
          `Please type ${
            !state.batch
              ? "Batch Number"
              : !state.partyId
              ? "Account Number"
              : !state.amount
              ? "Amount"
              : ""
          }`
        );
      }
      itemsQueue[editedItem] = state;
      setItemsQueue([...itemsQueue]);
      setEditedItem(null);
      clearState();
    }
  };

  // ---------------------- EDIT SINGLE API ------------------

  const updateSingleApi = async () => {
    const payload = {
      id: state.id,
      batchNo: Number(state.batch),
      partyId: Number(state.partyId),
      charges: Number(state.charges),
      debit: Number(state.netAmount),
    };

    console.log(payload, "payyyyyyyyy");
    const response = await updateSale(payload, access_token);
    if (response.success) {
      itemsQueue[editedItem] = state;
      // await editHandler();
      message.success(response.message);
      clearState();
      setFieldsShow(false);
    } else {
      message.error(response.message);
    }
  };

  const deleteItem = (index) => {
    // const prevObject = itemsQueue[i]
    itemsQueue.splice(index, 1);
    setItemsQueue([...itemsQueue]);
    setEditedItem(null);
    clearState();
  };

  // Caling Save API
  const save = async () => {
    if (!shift) return message.error("Please type shift!");
    if (itemsQueue.length === 0) return message.error("Add minimun 1 Entry");
    setIsButtonDisabled(true);

    const payload = itemsQueue.reduce((acc, curr) => {
      return [
        ...acc,
        {
          enteredOn: dateEntered,
          shift: Number(shift),
          batchNo: Number(curr.batch),
          partyId: Number(curr.partyId),
          charges: Number(curr.charges),
          debit: Number(curr.netAmount),
          grpId: Number(user.grpId),
          siteId: Number(user.siteId),
          companyCode: Number(user.companyCode),
        },
      ];
    }, []);
    console.log(payload, "payyy");
    try {
      const result = await saveData(payload, access_token);
      if (result.success) {
        clearStates();
        message.success(result.message || "Successfully entered!");
      }
    } catch (error) {
      console.error("Error while saving:", error);
    } finally {
      setIsButtonDisabled(false); // Re-enable the button after the async operation completes

      // Enable the button again, whether the API call succeeds or fails
    }
  };

  // Edit Data

  const [editPopup, setEditpopup] = useState(false);
  const edit = async () => {
    setEditpopup(true);
  };

  const editHandler = async () => {
    if (!dateEntered) return message.error("Please type Date!");
    if (!shift) return message.error("Please type shift!");
    const results = await getDataByEnteredOn(dateEntered, shift, access_token);
    if (results.success) {
      console.log(results, "ressaaaaa");
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            batch: Number(curr.batchNo),
            partyId: Number(curr.partyId),
            partyName: curr.party.partyName,
            charges: Number(curr.charges),
            netAmount: Number(curr.debit),
            amount: Number(parseFloat(curr.debit) + parseFloat(curr.charges)),
            items: state.items,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setEditpopup(false);
      setDateEntered("");
      setShift("");
      setType("EDIT");
    } else {
      setDateEntered("");
      setShift("");
      setEditpopup(false);
      message.error(results.message);
    }
  };
  console.log(state, "itemQ");

  // Delete Single Entry

  const deleteCoupon = async (id) => {
    const results = await deleteSingleCardSale(id, access_token);
    if (results.success) {
      if (itemsQueue.length !== 1) {
        await editHandler();
      } else {
        setItemsQueue([]);
      }
      message.success("Record Deleted Successfully !");
      // clearStates()
    } else {
      message.error(results.message);
    }
  };

  const confirmDelete = (id) => {
    console.log("deleteSingle");
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this Record?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deleteCoupon(id),
    });
  };

  // Delete By Date

  const [deletePopup, setDeletepopup] = useState(false);
  const deletePurchase = () => {
    setDeletepopup(true);
  };

  const deleteCreditHandler = async () => {
    const results = await deleteByDate(dateEntered, shift, access_token);
    if (results.success) {
      clearStates();
      message.success("Record Deleted Successfully !");
      clearStates();
      setDeletepopup(false);
    } else {
      setDeletepopup(false);
      message.error(results.message);
      setDateEntered("");
      setShift("");
    }
  };
  const confirmDeleteAll = () => {
    modal.confirm({
      title: `Confirm`,
      content: "Are you sure you want to delete this Credit Sale?",
      okText: "Delete",
      cancelText: "Cancel",
      onOk: () => deleteCreditHandler(),
    });
  };

  const orderByDesc = async () => {
    const result = await descCard(access_token);
    if (result.success) {
      const payload = result.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            batch: Number(curr.batchNo),
            partyId: Number(curr.partyId),
            partyName: curr.party.partyName,
            charges: Number(curr.charges),
            netAmount: Number(curr.debit),
            amount: Number(parseFloat(curr.debit) + parseFloat(curr.charges)),
            items: state.items,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      console.log(result.data, "order data");
      setDateEntered(result.data[0].enteredOn);
      setShift(result.data[0].shift);
      setTypeLast(EMeters.LAST);
    } else {
      message.warning(result.message);
    }
  };

  const orderByAsc = async () => {
    const result = await ascCard(access_token);
    if (result.success) {
      const payload = result.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            batch: Number(curr.batchNo),
            partyId: Number(curr.partyId),
            partyName: curr.party.partyName,
            charges: Number(curr.charges),
            netAmount: Number(curr.debit),
            amount: Number(parseFloat(curr.debit) + parseFloat(curr.charges)),
            items: state.items,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(result.data[0].enteredOn);
      setShift(result.data[0].shift);
      setTypeLast(EMeters.LAST);
    } else {
      message.warning(result.message);
    }
  };
  const onePreDate = async () => {
    const payload = {
      enteredOn: dateEntered,
      shift,
    };
    const result = await oneDayPrevious(payload, access_token);
    if (result.success) {
      const payload = result.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            batch: Number(curr.batchNo),
            partyId: Number(curr.partyId),
            partyName: curr.party.partyName,
            charges: Number(curr.charges),
            netAmount: Number(curr.debit),
            amount: Number(parseFloat(curr.debit) + parseFloat(curr.charges)),
            items: state.items,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(result.data[0].enteredOn);
      setShift(result.data[0].shift);
    } else {
      message.warning(result.message);
    }
  };

  const oneNextDate = async () => {
    const payload = {
      enteredOn: dateEntered,
      shift,
    };
    const result = await oneDayNext(payload, access_token);
    if (result.success) {
      const payload = result.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            dateEntered: curr.enteredOn,
            shift: curr.shift,
            batch: Number(curr.batchNo),
            partyId: Number(curr.partyId),
            partyName: curr.party.partyName,
            charges: Number(curr.charges),
            netAmount: Number(curr.debit),
            amount: Number(parseFloat(curr.debit) + parseFloat(curr.charges)),
            items: state.items,
            parties: state.parties,
          },
        ];
      }, []);
      setItemsQueue(payload);
      setDateEntered(result.data[0].enteredOn);
      setShift(result.data[0].shift);
    } else {
      message.warning(result.message);
    }
  };

  const getBankCharges = async () => {
    const data = await getSingleParty(state.partyId, access_token);
    console.log(data.data, "dataaaaPetryId");
    if (data.success) {
      setState({
        ...state,
        partyCharges: data.data.bChrages,
      });
    }
  };
  useEffect(() => {
    if (state.partyId) {
      getBankCharges();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.partyId]);



  useEffect(() => {
    const calculatedCharges = (
      (state.amount * state.partyCharges) /
      100
    ).toFixed(2);
    setState((prevState) => ({ ...prevState, charges: calculatedCharges }));
  }, [state.amount, state.partyCharges]);

  useEffect(() => {
    const calculatedNetAmount = (state.amount - state.charges).toFixed(2);
    setState((prevState) => ({ ...prevState, netAmount: calculatedNetAmount }));
  }, [state.amount, state.charges]);

  const menu = (index) => {
    return (
      <Menu>
        <Menu.Item key="0">
          <button
            onClick={() => {
              setFieldsShow(true);
              setEditedItem(index);
              setState(itemsQueue[index]);
            }}
          >
            Edit
          </button>
        </Menu.Item>
        <Menu.Item key="1">
          <button
            onClick={() => {
              itemsQueue[index].id
                ? confirmDelete(itemsQueue[index].id)
                : deleteItem(index);
            }}
          >
            {" "}
            Delete
          </button>
        </Menu.Item>
      </Menu>
    );
  };

  let totalSum = 0;
  itemsQueue.forEach((ele) => {
    totalSum += Number(ele.amount);  // Ensuring amount is treated as a number
  });

  const inputRefs = {};
  const addInputFieldRef = (ref, fieldName) => {
    if (ref && fieldName) {
      inputRefs[fieldName] = ref;
    }
  };
  const handleEnterKey = (e, fieldName) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior of the "Enter" key

      // Trigger addItem function if the current field is "amount"
      if (fieldName === "amount") {
        Boolean(editedItem != null) ? editItem() : addItem();
      } else {
        const currentFieldName = fieldName;

        // Define the order of input fields
        const fieldOrder = [
          "dateEntered",
          "shift",
          "partyId",
          "accountName",
          "batch",
          "amount",
          // Add more field names as needed
        ];

        // Find the index of the current field in the order array
        const currentIndex = fieldOrder.indexOf(currentFieldName);
        console.log(currentIndex, "current Inddd");
        if (currentIndex !== -1 && currentIndex < fieldOrder.length - 1) {
          // Move focus to the next input field
          const nextFieldName = fieldOrder[currentIndex + 1];
          const nextInput = inputRefs[nextFieldName];

          if (nextInput) {
            nextInput.focus();
          }
        }
      }
    }
  };

  return (
    <div className="flex  bg-black lube-main">
      <SideBar />
      <div className="h-full  flex flex-col content-center  w-full">
        <div className="meterTableMain ml-10 mt-6o mr-10">
          {contextHolder}
          <div className="bg-blue-500 headingBox flex justify-between">
            <h3 className=" text-white tableHeading pl-10">
              CREDIT CARD ENTRY FORM
            </h3>
          </div>
          <div className="bg-blue-500">
            <div className="flex content-center pt-5">
              <input
                type="date"
                className="text-black inpTxt p-2 h-8 ml-11 mb-3"
                value={dateEntered}
                onChange={(e) => setDateEntered(e.target.value)}
                onKeyDown={(e) => handleEnterKey(e, "dateEntered")}
                ref={(ref) => addInputFieldRef(ref, "dateEntered")}
              />
              <input
                type="number"
                name="shift"
                value={shift}
                placeholder="Shift"
                onChange={(e) => setShift(e.target.value)}
                className=" text-black inpTxt p-1 h-8 ml-3 w-40"
                onKeyDown={(e) => handleEnterKey(e, "shift")}
                ref={(ref) => addInputFieldRef(ref, "shift")}
              />
              <input
                type="text"
                name=""
                placeholder="S/M ID "
                value={user.id}
                className=" text-black inpTxt p-1 h-8 ml-3 w-40"
              />
              <input
                type="text"
                name=""
                placeholder="Name"
                value={user.name}
                className=" text-black inpTxt p-1 h-8 ml-3 w-64"
              />
              <input
                type="text"
                name=""
                placeholder="Report No"
                className=" text-black inpTxt p-1 h-8 ml-3 w-36"
              />
            </div>
          </div>

          <div className="">
            {fieldsShow && (
              <div className="flex content-center flex-wrap pt-5 ml-11">
                <Select
                  showSearch
                  placeholder="A/C No."
                  name="partyId"
                  className="ant-select bg-black text-slate-400 inpTxt text-sm mt-2 p-1 h-9 ml-1  w-56"
                  optionFilterProp="children"
                  value={state.partyId || "A/C No."}
                  onChange={(e) => {
                    const _party = state.parties.find((el) => el.partyId === e);
                    if (_party) {
                      setState({
                        ...state,
                        partyId: e,
                        partyName: _party.PartyName,
                      });
                    } else {
                      setState({
                        ...state,
                        partyId: e,
                        partyName: "",
                      });
                    }
                  }}
                  onKeyDown={(e) => handleEnterKey(e, "partyId")}
                  ref={(ref) => addInputFieldRef(ref, "partyId")}
                >
                  <Option value={0}>None</Option>
                  {state.parties.map((el) => (
                    <Option
                      value={el.partyId}
                    >{`${el.partyId} - ${el.PartyName}`}</Option>
                  ))}
                </Select>
                <Select
                  showSearch
                  placeholder="Card Name"
                  name="accountName"
                  className="ant-select bg-black text-slate-400 inpTxt text-sm mt-2 p-1 h-9 ml-1  w-28"
                  optionFilterProp="children"
                  value={state.partyName || "Card Name"}
                  onChange={(e) => {
                    const { PartyName } = state.parties.find(
                      (el) => el.partyId === e
                    );
                    setState({
                      ...state,
                      partyId: e,
                      partyName: PartyName,
                    });
                  }}
                  onKeyDown={(e) => handleEnterKey(e, "accountName")}
                  ref={(ref) => addInputFieldRef(ref, "accountName")}
                >
                  {state.parties.map((el) => (
                    <Option value={el.partyId}>{el.PartyName}</Option>
                  ))}
                </Select>
                <input
                  type="number"
                  placeholder="Batch#"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-16"
                  name="batch"
                  value={state.batch}
                  onChange={onChangeText}
                  onKeyDown={(e) => handleEnterKey(e, "batch")}
                  ref={(ref) => addInputFieldRef(ref, "batch")}
                />
                <input
                  type="number"
                  placeholder="No of Trns"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-16"
                  name="noOfTransaction"
                  value={state.noOfTransaction}
                  onChange={onChangeText}
                />
                <input
                  type="text"
                  placeholder="CC No"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-16"
                  name="CCNo"
                  value={state.CCNo}
                  onChange={onChangeText}
                />
                <Select
                  className="ant-select bg-black text-slate-400 inpTxt text-sm mt-2 p-1 h-9 ml-1  w-20"
                  showSearch
                  placeholder="Select item"
                  optionFilterProp="children"
                  value={state.itemCode || "Item"}
                  onChange={(e) => {
                    if (e === 0) {
                      // If the selected value is 0 (None)
                      setState({
                        ...state,
                        itemCode: 0,
                        itemName: "",
                      });
                    } else {
                      const { itemName: productName } = state.items.find(
                        (el) => el.itemCode === e
                      );
                      setState({
                        ...state,
                        itemCode: e,
                        itemName: productName,
                      });
                    }
                  }}
                >
                  <Option value={0}>None</Option>
                  {state.items.map((el) => (
                    <Option value={el.itemCode}>{`${el.itemCode}`}</Option>
                  ))}
                </Select>
                <input
                  type="text"
                  placeholder="Description"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-16"
                  name="description"
                  value={state.description}
                  onChange={onChangeText}
                />
                <input
                  type="number"
                  name="quantity"
                  placeholder="Quantity"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-16"
                  value={state.quantity}
                  onChange={(e) => {
                    if (state.saleRate) {
                      setState({
                        ...state,
                        amount: parseFloat(
                          e.target.value * state.saleRate
                        ).toFixed(2),
                        quantity: e.target.value,
                      });
                    } else {
                      setState({ ...state, quantity: e.target.value });
                    }
                  }}
                />
                <input
                  type="number"
                  name="saleRate"
                  placeholder="Sale Rate"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-16"
                  value={state.saleRate}
                  onChange={(e) => {
                    // if (state.quantity) {
                    //   setState({
                    //     ...state,
                    //     amount: e.target.value * state.quantity,
                    //   });
                    // } else {
                    // }
                    setState({ ...state, saleRate: e.target.value });
                  }}
                />
                <input
                  type="number"
                  placeholder="S/Charges"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-16"
                  name="partyCharges"
                  value={state.partyCharges || 0}
                  // onChange={onChangeText}
                />
                <input
                  type="number"
                  placeholder="S/Charges"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-16"
                  name="charges"
                  value={state.charges}
                  readOnly
                  // value={((state.amount * state.partyCharges) / 100).toFixed(2)}
                />

                <input
                  type="number"
                  name="amount"
                  placeholder="Amount"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-28"
                  // value={(state.netAmount*state.charges/100).toFixed(2)}
                  value={state.amount}
                  onKeyDown={(e) => handleEnterKey(e, "amount")}
                  ref={(ref) => addInputFieldRef(ref, "amount")}
                  onChange={(e) => {
                    // if (state.amount) {
                    //   setState({
                    //     ...state,
                    //     quantity: parseFloat(
                    //       e.target.value / state.saleRate
                    //     ).toFixed(2),
                    //     amount: e.target.value,
                    //   });
                    // } else {
                    // }
                    setState({ ...state, amount: e.target.value });
                  }}
                />
                <input
                  type="number"
                  name="netAmount"
                  placeholder="Batch Amount"
                  className="bg-black text-slate-400 inpTxt text-sm mt-2 p-2 h-9 ml-1  w-28"
                  value={state.netAmount}
                  readOnly
                />

                {Boolean(editedItem != null) ? (
                  <button
                    onClick={editItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white  ml-3 mt-2 h-9py-1 px-4 rounded"
                  >
                    EDIT
                  </button>
                ) : (
                  <button
                    onClick={addItem}
                    className="bg-blue-500 hover:bg-blue-700 text-white  ml-1 py-1 h-9 mt-2 px-4 text-xs font-medium rounded"
                  >
                    ADD +
                  </button>
                )}
              </div>
            )}
          </div>

          <div className="div">
            <div className="flex">
              <div className="overflow-x-auto   shadow-md sm:rounded-lg tableDiv p-5 pl-10  w-full">
                <table className=" w-full text-sm text-left text-gray-500 dark:text-gray-400">
                  <thead className="bg-blue-500 text-white uppercase dark:bg-gray-700 tableHeading  dark:text-gray-400">
                    <tr>
                      <th
                        className="pl-3 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        S.N
                      </th>
                      <th
                        className=" pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        BATCH NO
                      </th>
                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        A/C
                      </th>
                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        CARD NO.
                      </th>
                      <th
                        className=" pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        TRNS#
                      </th>
                      <th
                        className=" pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        S/CHARGES
                      </th>
                      <th
                        className=" pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        AMOUNT
                      </th>
                      <th
                        className="  pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium    "
                        scope="col"
                      >
                        NRT AMOUNT
                      </th>
                      {(type === "EDIT" || type === "SAVE") && (
                        <th
                          className=" pl-2 pr-2  py-3   bg-blue-500  text-left text-xs font-medium "
                          scope="col"
                        >
                          ACTION
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody className="tableBody">
                    {itemsQueue.map((ele, i) => {
                      return (
                        <tr className="tbodyData text-white">
                          <td className="pl-3 pt-3 pb-3 pr-1 ">{i + 1}</td>
                          <td className="pt-3 pb-3  pl-2 pr-1   font-medium   ">
                            <p className="font-medium ">{ele.batch}</p>
                          </td>{" "}
                          <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">{ele.partyId}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">{ele.partyName}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">
                              {ele.noOfTransaction}
                            </p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">{ele.charges}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">{ele.amount}</p>
                          </td>
                          <td className="pt-3 pb-3  pl-2 pr-1 ">
                            <p className="font-medium ">{ele.netAmount}</p>
                          </td>
                          {(type === "EDIT" || type === "SAVE") && (
                            <td className="pt-3 pb-3  pl-2 pr-1 ">
                              <Dropdown
                                overlay={menu(i)}
                                placement="bottomLeft"
                              >
                                <Button>Action</Button>
                              </Dropdown>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="flex justify-end">
                  <input
                    type="text"
                    readOnly
                    placeholder=""
                    name=""
                    id=""
                    value={totalSum}
                    className="mt-2 pl-10 pt-1 pb-1 w-32 bg-black text-white outline-none"
                  />
                </div>
                <div className="flex justify-between">
                  <div className="flex">
                    {type === "ADD" && (
                      <button
                        onClick={addSale}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                      >
                        <AiFillFileAdd className="mr-2 mt-1" />

                        <span>Add</span>
                      </button>
                    )}

                    {type === "SAVE" && (
                      <button
                        onClick={save}
                        // className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                        className={`bg-blue-500 hover:bg-blue-700 flex h-9 text-white mt-3 py-1 px-4 rounded ${
                          isButtonDisabled
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        disabled={isButtonDisabled}
                      >
                        <AiFillSave className="mt-1 mr-2 " />
                        <span>Save</span>
                      </button>
                    )}

                    {type === "ADD" && (
                      <button
                        onClick={edit}
                        className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                      >
                        <AiFillEdit className="mr-2 mt-1" />

                        <span>Edit</span>
                      </button>
                    )}

                    <button
                      onClick={() => deletePurchase()}
                      className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                      disabled={type !== "ADD"}
                    >
                      <AiFillDelete className="mr-2 mt-1" />

                      <span>Delete</span>
                    </button>
                    <button
                      onClick={clearStates}
                      className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                    >
                      {" "}
                      <BiExit className="mr-2 mt-1" />
                      {type === "EDIT" ? "Done" : "Exit"}
                    </button>
                  </div>
                  <div className="flex content-end mt-3 bg-white justify-end"></div>
                  {isVisible && (
                    <div>
                      <button
                        onClick={orderByAsc}
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-3 py-1 px-4 rounded"
                      >
                        <img src={`./img/first.png`} alt="" />
                      </button>
                      {typeLast === "LAST" && (
                        <button
                          onClick={onePreDate}
                          className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                        >
                          <img src={`./img/previous.png`} alt="" />
                        </button>
                      )}
                      {typeLast === "LAST" && (
                        <button
                          onClick={oneNextDate}
                          className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                        >
                          <img src={`./img/next.png`} alt="" />
                        </button>
                      )}
                      <button
                        onClick={orderByDesc}
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                      >
                        <img src={`./img/latest.png`} alt="" />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popup popup={editPopup} handlePopup={setEditpopup} onOk={editHandler}>
        <div>
          <div className="flex justify-evenly">
            <h2>Please type Date & Shift</h2>
          </div>
          <div className="flex justify-evenly mt-2">
            <input
              style={{
                border: "1px solid",
              }}
              autoFocus
              type="date"
              value={dateEntered}
              onChange={(e) => setDateEntered(e.target.value)}
              className="text-black inpTxt p-2 h-8 ml-11 mb-3"
            />
            <input
              style={{
                border: "1px solid",
              }}
              autoFocus
              placeholder="Shift"
              type="number"
              value={shift}
              onChange={(e) => setShift(e.target.value)}
              className=" text-black inpTxt p-1 h-8 ml-3 w-40"
            />
          </div>
        </div>
      </Popup>
      <Popup
        popup={deletePopup}
        handlePopup={setDeletepopup}
        onOk={confirmDeleteAll}
      >
        <div>
          <div className="flex justify-evenly">
            <h2>Please type Date & Shift</h2>
          </div>
          <div className="flex justify-evenly mt-2">
            <input
              style={{
                border: "1px solid",
              }}
              autoFocus
              type="date"
              value={dateEntered}
              onChange={(e) => setDateEntered(e.target.value)}
              className="text-black inpTxt p-2 h-8 ml-11 mb-3"
            />
            <input
              style={{
                border: "1px solid",
              }}
              autoFocus
              placeholder="Shift"
              type="number"
              value={shift}
              onChange={(e) => setShift(e.target.value)}
              className=" text-black inpTxt p-1 h-8 ml-3 w-40"
            />
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default Cards;
